import React from 'react'

import withApiService from '../hoc/with-api-service'
import withData from '../hoc/with-data'
import withSlider from '../hoc/with-slider'
import {Link} from 'react-router-dom'

const OverlookedSlider = ({response, setSliderData, index, images, isViewedArrow, handleArrowClick,
                            updateSliderBackgrounds, updateSliderComponentData}) => {
  const {data} = response;

  if (data) {
    setSliderData(data)
  }

  const itemList = images && images.map((_, i) => {
    if (i > 4) {
      return null
    }
    const currentItem = index + i;
    const id = updateSliderComponentData(currentItem).id;

    return (
      <div className={`overlooked-slider__item overlooked-slider__item-${i}`}
           style={updateSliderBackgrounds(currentItem)} key={id}>
        <Link to={`/product-card-desktop/${id}`}/>
      </div>
    )
  });

  return (
    <div className="overlooked-slider">
      {isViewedArrow && <div className="overlooked-slider__arrow overlooked-slider__arrow_left arrow"
                             onClick={handleArrowClick}/>}
      {itemList}
      {isViewedArrow && <div className="overlooked-slider__arrow overlooked-slider__arrow_right arrow"
                             onClick={handleArrowClick}/>}
    </div>
  )
};

const mapMethodsToProps = (apiService) => {
  return {
    getData: apiService.getProducts
  };
};

export default withApiService(mapMethodsToProps)(withData(withSlider(OverlookedSlider)));